import type { jsPDF } from 'jspdf'

import {
  geistBold,
  geistMedium,
  geistRegular,
  geistSemibold,
} from './geistFont'

export type PdfFontWeight = 'normal' | 'medium' | 'semibold' | 'bold'

export function registerGeistFonts(pdf: jsPDF) {
  pdf.addFileToVFS('Geist-Regular.ttf', geistRegular)
  pdf.addFont('Geist-Regular.ttf', 'Geist', 'normal')

  pdf.addFileToVFS('Geist-Medium.ttf', geistMedium)
  pdf.addFont('Geist-Medium.ttf', 'Geist', 'normal', 500)

  pdf.addFileToVFS('Geist-Semibold.ttf', geistSemibold)
  pdf.addFont('Geist-Semibold.ttf', 'Geist', 'normal', 600)

  pdf.addFileToVFS('Geist-Bold.ttf', geistBold)
  pdf.addFont('Geist-Bold.ttf', 'Geist', 'bold')
}

export function setGeistFont(pdf: jsPDF, weight: PdfFontWeight) {
  if (weight === 'medium') {
    pdf.setFont('Geist', 'normal', 500)
  } else if (weight === 'semibold') {
    pdf.setFont('Geist', 'normal', 600)
  } else if (weight === 'bold') {
    pdf.setFont('Geist', 'bold')
  } else {
    pdf.setFont('Geist', 'normal')
  }
}

export function hexToRgb(hex: string): [number, number, number] {
  return [
    parseInt(hex.slice(1, 3), 16),
    parseInt(hex.slice(3, 5), 16),
    parseInt(hex.slice(5, 7), 16),
  ]
}
